import {notification} from 'antd';

export default function(err) {
    console.error('[VALIDATION ERROR', err);
    notification.error({
        message: 'Validation Error',
        description: 'Please enter all required fields and try again.'
    });
}
